import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { promoProductsSelector } from '../../../../../../redux/reseller-home-page/reseller-home-page.selectors';
import { PromotedProductsBlock as Component } from './promoted-products-block';
const mapStateToProps = createStructuredSelector({
  products: promoProductsSelector
});
export const PromotedProductsBlock = connect(mapStateToProps)(Component);